import {
  SET_LANGUAGE,
  SET_LANGUAGE_SUCCESS,
  SET_LANGUAGE_FAILURE,
} from "./types";

// Action to set language
export const setLanguage = (language: string) => ({
  type: SET_LANGUAGE,
  payload: language,
});

// Action dispatched when language setting is successful
export const setLanguageSuccess = (language: string) => ({
  type: SET_LANGUAGE_SUCCESS,
  payload: language,
});

// Action dispatched when language setting fails
export const setLanguageFailure = (error: string) => ({
  type: SET_LANGUAGE_FAILURE,
  payload: error,
});
